<div class="inline-element summary">
  <span class="label">{{nome}}</span>
  <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>
  <span>{{lancamentos.length}} lançamentos</span>
  <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>
  <span>Total: {{ valorLancamentos | currency:'BRL' }}</span>
</div>

<mat-divider class="horizontal-divider"></mat-divider>

<p-table #dt [value]="lancamentos" dataKey="id" responsiveLayout="scroll">
      
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="data">Data<p-sortIcon field="data" /></th>
      <th pSortableColumn="lancamento">Lançamento<p-sortIcon field="lancamento" /></th>
      <th pSortableColumn="valor">Valor<p-sortIcon field="valor" /></th>
    </tr>
  </ng-template>

  <!-- Modelo da Tabela Principal -->
  <ng-template #body let-lancamento let-rowIndex="rowIndex" let-editing="editing" let-expanded="expanded">
    <tr [pSelectableRow]="lancamento" [pSelectableRowIndex]="rowIndex" [pEditableRow]="lancamento">
      <td>
        {{ lancamento.data | date:'dd/MM/yyyy' }}
      </td>
      <td>
        {{ lancamento.descricao }}
      </td>
      <td>
        <div [ngClass]="{'red-text': lancamento.valor < 0 }">
          {{ lancamento.valor | currency:'BRL' }}
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>